import { Component, Input, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from '../../../../shared/models/subject';
import { enumReviewStatus } from 'app/shared/models/review';
import { ReviewDialogComponent } from 'app/main/content/referrals/review-dialog/review-dialog.component';

@Component({
  selector: 'review-list-widget',
  templateUrl: './review-list-widget.component.html',
  styleUrls: ['./review-list-widget.component.scss'],
  animations: fuseAnimations,
})
export class ReviewListWidgetComponent implements OnInit {
  _subject: Subject;
  title = '';
  data = [];
  selected: any;

  //added empty inputs to remove errors - YA
  @Input() id: Number;
  @Input() subjectId: Number;
  @Input() processTypeId: Number;
  @Input() settings: any;

  @Input() set subject(val: Subject) {
    if (val) {
      this.update(val);
    }
  }

  constructor(public dialog: MatDialog) {}

  ngOnInit() {
    this.title = 'Reviews';
  }

  select(row) {
    this.selected = row;
  }

  update(subject?: Subject) {
    subject = subject || this._subject;
    if (subject) {
      this._subject = subject;
    }
    if (this._subject) {
      const data = [];
      this._subject.subjectReviews.sort(
        (a, b) =>
          new Date(b.review.reviewDate).getTime() -
          new Date(a.review.reviewDate).getTime()
      );
      this._subject.subjectReviews.forEach((subjectReview) => {
        data.push({
          id: subjectReview.id,
          reviewDate: subjectReview.review.reviewDate,
          label: subjectReview.review.label
            ? ` - ${subjectReview.review.label}`
            : ``,
          override: subjectReview.review.override,
          status: enumReviewStatus[subjectReview.review.status],
          class: this.getClass(subjectReview.review.status),
          secondary: subjectReview.review.reviewedBy
            ? 'Reviewed by: ' + subjectReview.review.reviewedBy.fullName
            : '',
          subjectReview,
        });
      });
      this.data = data;
    }
  }

  view(row) {
    if (row && row.id) {
      this.dialog.open(ReviewDialogComponent, {
        data: {
          review: row.subjectReview.review,
          subject: this._subject,
        },
      });
    }
  }

  private getClass(status) {
    switch (status) {
      case enumReviewStatus.Accepted:
        return 'bg-green';
      case enumReviewStatus.Rejected:
        return 'bg-red';
      case enumReviewStatus.Reviewed:
        return 'mat-accent-bg';
      default:
        return 'bg-orange';
    }
  }
}
